(function () {
  var bar = document.getElementById('irekowan-cv-stickybar');
  if (!bar) return;

  var visible = false;

  function update() {
    var shouldShow = window.scrollY > 700;
    if (shouldShow === visible) return;
    visible = shouldShow;
    bar.classList.toggle('irekowan-cv-stickybar--visible', visible);
    bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
  }

  window.addEventListener('scroll', update, { passive: true });
  update();
})();
